<template>
  <v-overlay color="black" opacity="0.8" :value="show">
    <v-carousel hide-delimiters height="80vh" :value="value" ref="carousel">
      <v-carousel-item
        v-for="(image, key) in images"
        :key="key"
        contain
        :src="image.src"
        :value="key"
        reverse-transition="fade-transition"
        transition="fade-transition"
      >
      </v-carousel-item>
      <v-btn class="black" large icon absolute top right @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-carousel>
  </v-overlay>
</template>

<script>

// TODO: close button get in the way of wide image
// TODO: should close on overlay clicked
// TODO: doesn't work in mobile

export default {
  props: ["images", "value"],
  computed: {
    show() {
      return this.value != null
    },
  },
  watch: {
    value(newValue) {
      if (newValue != null) {
        window.addEventListener("keydown", this.handleKeydown, null)
        document.documentElement.style.overflow = "hidden"
      } else {
        window.removeEventListener("keydown", this.handleKeydown)
        document.documentElement.style.overflow = "auto"
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", null)
    },
    handleKeydown(e) {
      if (this.value == null) {
        return
      }
      switch (e.keyCode) {
        case 27:
          this.close()
          break
        case 37:
          this.$refs.carousel.prev()
          break
        case 39:
          this.$refs.carousel.next()
          break
      }
    },
  },
}
</script>
